





import { Vue, Component, Prop } from 'vue-property-decorator';
import EditOrg from './EditOrg.vue';
@Component({
  components: {
    EditOrg,
  },
})
export default class Settings extends Vue {
}
